import { addNotify } from 'features/notify';
import dayjs from 'dayjs';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';
import { checkPaymentsAllowed } from 'features/finance/data';

const actionTypes = {
  ACTION_PROCESSING: 'auth/ACTION_PROCESSING',
  SIGN_IN_SUCCESS: 'auth/SIGN_IN_SUCCESS',
  LOGOUT: 'auth/LOGOUT',
  GET_BALANCE: 'auth/GET_BALANCE',
  SET_IS_PROCESS: 'auth/SET_IS_PROCESS',
  GET_NOTIFICATIONS: 'auth/GET_NOTIFICATIONS',
  SEEND_NOTIFICATIONS: 'auth/SEENED_NOTIFICATIONS',
  REMOVE_SEEND_NOTIFICATIONS: 'auth/REMOVE_SEEND_NOTIFICATIONS',
  CHANGE_LOGIN_ATTEMPTS: 'auth/CHANGE_LOGIN_ATTEMPTS',
  SET_SEMI_AUTO_WITHDRAWAL_ENABLED: 'auth/SET_SEMI_AUTO_WITHDRAWAL_ENABLED',
  GET_METADATA: 'auth/GET_METADATA',
  SET_IS_HIGHER_AGENTS_OPERATIONS_RESTRICTED: 'auth/SET_IS_HIGHER_AGENTS_OPERATIONS_RESTRICTED',
};

const changeLoginAttempts = attempts => async dispatch => {
  dispatch({ type: actionTypes.CHANGE_LOGIN_ATTEMPTS, payload: attempts });
};

const login = (username, password, callback) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
  const response = await api.auth.signIn(username, password);

  if (response.success) {
    dispatch(checkAuth());
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
    dispatch(changeLoginAttempts());
  }

  if (callback) callback(response.success);

  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
};

const checkAuth = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.checkAuth();

  if (response.success && response.data.role !== 0) {
    dispatch({ type: actionTypes.SIGN_IN_SUCCESS, payload: response.data });
    dispatch(getBalance());
    if (checkPaymentsAllowed(response.data)) {
      dispatch(getMetadata());
    }
    dispatch(changeLoginAttempts(0));
  } else {
    // const { locale } = getState().locale;
    // const errorMessage = getErrorMessage(locale, response);
    // dispatch(addNotify(errorMessage, 'error'));
    dispatch({ type: actionTypes.LOGOUT });
  }
};

const getBalance = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.getBalance();
  if (response.success) {
    dispatch({ type: actionTypes.GET_BALANCE, payload: response.data });
    if (response.data.isBanned) {
      dispatch(logOut());
    }
  }
};

const getMetadata = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.getMetadata();
  if (response.success) {
    dispatch({ type: actionTypes.GET_METADATA, payload: response.data });
  }
};

const logOut = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.logOut();
  dispatch({ type: actionTypes.LOGOUT });
};

const getNotifications = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.agentAdmin.getNotifications();

  if (response.success && response.data?.length > 0) {
    dispatch({ type: actionTypes.GET_NOTIFICATIONS, payload: response.data });
  }
};

const dropNotifications = id => async (dispatch, getState) => {
  const { notifications } = getState().auth;

  const updatedItems = notifications.filter(item => item.id !== id);

  dispatch({ type: actionTypes.GET_NOTIFICATIONS, payload: [...updatedItems] });
};

const addSeenNotifications = id => async (dispatch, getState) => {
  const { seendNotifications } = getState().auth;

  const updatedItems = [...seendNotifications, id];

  dispatch({ type: actionTypes.SEEND_NOTIFICATIONS, payload: [...updatedItems] });
};
const removeSeenNotifications = id => async (dispatch, getState) => {
  const { seendNotifications } = getState().auth;

  const updatedItems = seendNotifications.filter(item => item !== id);

  dispatch({ type: actionTypes.REMOVE_SEEND_NOTIFICATIONS, payload: [...updatedItems] });
};

const toggleSemiAutoWithdrawalEnabled = () => async (dispatch, getState, extra) => {
  const { semiAutoWithdrawalEnabled } = getState().auth;
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.auth.toggleSemiAutoWithdrawalEnabled({
    semi_auto_withdrawal_enabled: !semiAutoWithdrawalEnabled,
  });
  if (response.success) {
    dispatch({ type: actionTypes.SET_SEMI_AUTO_WITHDRAWAL_ENABLED, payload: response.data });
    dispatch(checkAuth());
  } else {
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const toggleHigherAgentsOperationsRestricted = () => async (dispatch, getState, extra) => {
  const { isHigherAgentsOperationsRestricted } = getState().auth;
  const { api } = extra;
  const { locale } = getState().locale;

  const nextValue = !isHigherAgentsOperationsRestricted;

  const response = await api.auth.toggleHigherAgentsOperationsRestricted({
    is_higher_agents_operations_restricted: nextValue,
  });

  if (response.success) {
    dispatch({ type: actionTypes.SET_IS_HIGHER_AGENTS_OPERATIONS_RESTRICTED, payload: nextValue });
  } else {
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
  }
};

export {
  actionTypes,
  login,
  logOut,
  checkAuth,
  getBalance,
  getMetadata,
  dropNotifications,
  getNotifications,
  addSeenNotifications,
  removeSeenNotifications,
  toggleSemiAutoWithdrawalEnabled,
  toggleHigherAgentsOperationsRestricted,
};
